const JustifiedGalleryBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="#ffd400" d="M2 2h20v10H2z" />
    <path d="M22 2v10H2V2h20m2-2H0v14h24V0z" fill="#333" />
    <path fill="#fff" d="M2 2h10v10H2z" />
    <circle cx="6" cy="6" r="2" fill="#333" />
    <g>
      <path fill="#ffd400" d="M2 20h6v2H2z" />
      <path d="M0 24h10v-6H0zm2-4h6v2H2z" fill="#333" />
      <path fill="#fff" d="M16 20h6v2h-6z" />
      <path d="M14 18v6h10v-6zm8 4h-6v-2h6z" fill="#333" />
    </g>
  </svg>
);

export default JustifiedGalleryBlockIcon;
